/* eslint-disable no-console */
(function () {
  'use strict';

  // ==============================================================
  // ==============================================================
  // ====  Configuration                                        ====
  // ====  Storefront token reused from existing theme JS       ====
  // ====  (component-variant-options.js, virtual-race-*.js).   ====
  // ====  If you ever rotate it, search & replace across       ====
  // ====  /assets/*.js so the theme stays in sync.             ====
  // ==============================================================
  // ==============================================================
  var STOREFRONT_ACCESS_TOKEN = '382d0c774e95be1f0d7c90e6c08bba49';
  var STOREFRONT_API_VERSION = '2023-01';

  var CURRENCY = 'USD';
  var CURRENCY_SYMBOL = '$';
  var CURRENCY_FRACTION = 2;

  var BRAND_ATTRIBUTE = 'CUSTOM';

  var variantCache = new Map();

  function getStorefrontEndpoint() {
    var apiDomain = (window.globalSpace && window.globalSpace.apiDomain) || '';
    return apiDomain + '/api/' + STOREFRONT_API_VERSION + '/graphql.json';
  }

  // ==============================================================
  // ====  In-page notice banner                                ====
  // ====  A persistent, dismissible banner we fully own. Used   ====
  // ====  for BOTH failure classes:                            ====
  // ====   - 'warning' (amber): kit not ready (sizes missing)   ====
  // ====   - 'error'  (red):   Shopify wouldn't add it          ====
  // ====  Why not the theme toast: global.js `_manageToggle`    ====
  // ====  counts animation frames as if 60Hz and halves the     ====
  // ====  timeout, so a 6s toast shows ~1s on high-refresh      ====
  // ====  displays — far too brief for a checkout-blocking      ====
  // ====  message. Appended to <body> (outside #kitBuilder) so   ====
  // ====  Kit Builder's Angular re-renders can't wipe it.       ====
  // ==============================================================
  function getKitNoticeEl() {
    var existing = document.getElementById('kb-cts-notice');
    if (existing) return existing;

    var el = document.createElement('div');
    el.id = 'kb-cts-notice';
    el.setAttribute('role', 'alert');
    el.style.cssText = [
      'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
      'z-index:2147483000', 'max-width:520px', 'width:calc(100% - 32px)',
      'box-sizing:border-box', 'padding:14px 44px 14px 16px',
      'border-radius:2px', 'border-left:4px solid transparent',
      'font-family:"Roboto-New", Roboto, sans-serif', 'font-size:14px',
      'line-height:1.4', 'box-shadow:0 4px 16px rgba(0,0,0,.18)', 'display:none'
    ].join(';');

    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss');
    close.innerHTML = '&times;';
    close.style.cssText = 'position:absolute;top:6px;right:10px;border:0;background:transparent;font-size:22px;line-height:1;cursor:pointer;color:inherit;opacity:.6';
    close.addEventListener('click', function () { el.style.display = 'none'; });

    var body = document.createElement('div');
    body.className = 'kb-cts-notice-body';

    el.appendChild(close);
    el.appendChild(body);
    document.body.appendChild(el);
    return el;
  }

  function showKitNotice(message, type) {
    var palette = type === 'error'
      ? { bg: '#f8d7da', border: '#dc3545', text: '#842029', lead: 'This order couldn’t be added to your cart' }
      : { bg: '#fff3cd', border: '#e0a800', text: '#664d03', lead: 'This order can’t be submitted in its current state' };

    var el = getKitNoticeEl();
    el.style.backgroundColor = palette.bg;
    el.style.borderLeftColor = palette.border;
    el.style.color = palette.text;

    var body = el.querySelector('.kb-cts-notice-body');
    body.innerHTML = '';
    var lead = document.createElement('div');
    lead.style.cssText = 'font-weight:700;margin-bottom:4px';
    lead.textContent = '⚠  ' + palette.lead + ':';
    var msg = document.createElement('div');
    msg.style.fontWeight = '500';
    msg.textContent = message;
    body.appendChild(lead);
    body.appendChild(msg);

    el.style.display = 'block';
  }

  function clearKitNotice() {
    var el = document.getElementById('kb-cts-notice');
    if (el) el.style.display = 'none';
  }

  // User-fixable problems (no size picked, only some players sized, etc.).
  // Kit Builder gives us no explicit "invalid" signal — it fires the callback
  // with the size fields left null — so this banner is the only thing telling
  // the customer what to fix.
  function notifyKitInputProblem(message) {
    showKitNotice(message, 'warning');
  }

  // Map a transform / cart-add failure to a customer-facing sentence. Shopify's
  // raw `description` (e.g. "Cannot find variant") is for us, not the shopper.
  function friendlyCartError(err) {
    if (err && err.name === 'CartAddError') {
      var desc = '';
      try { desc = (JSON.parse(err.body) || {}).description || ''; } catch (e) { /* not JSON */ }
      var d = desc.toLowerCase();
      if (/sold ?out|out of stock|stock|inventory|not available|unavailable/.test(d)) {
        return 'This item appears to be sold out, so we couldn’t add it. Please contact us and we’ll help sort it out.';
      }
      if (/find variant|variant/.test(d)) {
        return 'This design is temporarily unavailable to add to the cart. Please contact us so we can help.';
      }
      if (/maximum|minimum|limit|quantity/.test(d)) {
        return 'There’s a quantity limit on this item. Please adjust the amount, or contact us.';
      }
      if (desc) {
        return 'We couldn’t add your design to the cart (' + desc + '). Please try again, or contact us if it keeps happening.';
      }
      return 'We couldn’t add your design to the cart. Please try again, or contact us if it keeps happening.';
    }
    // SKU / variant resolution problems thrown by transformKitBuilderPayload.
    var m = (err && err.message) || '';
    if (/SKU|variant|available for sale/i.test(m)) {
      return 'This design isn’t available to add to the cart right now. Please contact us so we can help.';
    }
    // Network / unknown.
    return 'Something went wrong adding your design. Nothing has been charged — please try again, or contact us if it keeps happening.';
  }

  // Parse a matched variant node's `custom.personalizations` metafield into a
  // simple array of option records the map logic can read:
  //   [{ name: 'Custom Hoodie Pocket', type: 'personalization_select',
  //      options: [{ key, label, price }, ...] }]
  // Returns [] when the variant has no personalization record (the common case
  // for non-personalized products) — callers must treat that as "nothing to do".
  function parsePersonalizations(variantNode) {
    var mf = variantNode && variantNode.metafield;
    var nodes = (mf && mf.references && mf.references.nodes) || [];
    var records = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node || node.__typename !== 'Metaobject' || !Array.isArray(node.fields)) continue;
      var rec = { type: node.type, name: '', options: [] };
      for (var f = 0; f < node.fields.length; f++) {
        var field = node.fields[f];
        if (!field) continue;
        if (field.key === 'name') {
          rec.name = field.value || '';
        } else if (field.key === 'options') {
          // Stored as a JSON string: [{ key, label, price }, ...]
          try {
            var parsed = JSON.parse(field.value);
            if (Array.isArray(parsed)) rec.options = parsed;
          } catch (e) {
            console.warn('[KitBuilder] could not parse personalization options JSON:', e);
          }
        }
      }
      if (rec.name) records.push(rec);
    }
    return records;
  }

  /**
   * Resolve a Shopify variant from a SKU using the Storefront API. Also pulls
   * the variant's `custom.personalizations` record so the personalization map
   * can be applied (Shopify stays the source of truth for label + price).
   * Caches results in-memory keyed by SKU. Throws if no exact case-sensitive
   * match is found or if the matched variant is not availableForSale.
   *
   * @param {string} sku
   * @returns {Promise<{variantId:number, personalizations:Array}>}
   */
  async function lookupVariantBySku(sku) {
    if (!sku) throw new Error('lookupVariantBySku called without a SKU');
    if (variantCache.has(sku)) return variantCache.get(sku);

    var query = '\n      query getVariantBySku($query: String!) {\n        products(first: 5, query: $query) {\n          edges {\n            node {\n              variants(first: 100) {\n                edges {\n                  node {\n                    id\n                    sku\n                    availableForSale\n                    metafield(namespace: "custom", key: "personalizations") {\n                      type\n                      references(first: 20) {\n                        nodes {\n                          __typename\n                          ... on Metaobject {\n                            type\n                            fields { key value }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    ';

    // Shopify's Storefront API does NOT support a `sku:` query filter (that's
    // Admin API only). Passing the raw SKU as a free-text query DOES surface
    // products whose variant SKUs match — we then narrow to an exact-match
    // variant client-side.
    var response = await fetch(getStorefrontEndpoint(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({ query: query, variables: { query: sku } })
    });

    if (!response.ok) {
      throw new Error('Storefront API returned HTTP ' + response.status + ' for SKU "' + sku + '"');
    }

    var json = await response.json();
    var productEdges = (json && json.data && json.data.products && json.data.products.edges) || [];

    var match = null;
    for (var i = 0; i < productEdges.length && !match; i++) {
      var variantEdges = (productEdges[i].node && productEdges[i].node.variants && productEdges[i].node.variants.edges) || [];
      for (var j = 0; j < variantEdges.length; j++) {
        if (variantEdges[j].node && variantEdges[j].node.sku === sku) {
          match = variantEdges[j].node;
          break;
        }
      }
    }

    if (!match) throw new Error('No Shopify variant found for SKU "' + sku + '"');
    if (!match.availableForSale) throw new Error('Shopify variant for SKU "' + sku + '" is not available for sale');

    var gidParts = String(match.id).split('/');
    var numericId = parseInt(gidParts[gidParts.length - 1], 10);
    if (!numericId) throw new Error('Could not parse numeric variant ID from "' + match.id + '"');

    var resolved = {
      variantId: numericId,
      personalizations: parsePersonalizations(match)
    };
    variantCache.set(sku, resolved);
    return resolved;
  }

  // Kit Builder mixes Pascal/camel and nests most fields under `SingleItemCheckout`,
  // with `teamDetails` sometimes living under `webhookModel`. These helpers walk every
  // plausible container and return the first hit.
  function payloadContainers(payload) {
    if (!payload) return [];
    return [payload, payload.SingleItemCheckout, payload.webhookModel].filter(Boolean);
  }

  function pickFirstString(obj, keys) {
    if (!obj) return '';
    for (var i = 0; i < keys.length; i++) {
      var v = obj[keys[i]];
      if (typeof v === 'string' && v.length > 0) return v;
    }
    return '';
  }

  function pickStringFromContainers(containers, keys) {
    for (var i = 0; i < containers.length; i++) {
      var hit = pickFirstString(containers[i], keys);
      if (hit) return hit;
    }
    return '';
  }

  function extractSku(payload) {
    return pickStringFromContainers(payloadContainers(payload), ['Sku', 'SKU', 'sku', 'productSku']);
  }

  function extractSizes(payload) {
    var containers = payloadContainers(payload);
    var raw = null;
    for (var i = 0; i < containers.length && !raw; i++) {
      var c = containers[i];
      raw =
        (c.teamDetails && c.teamDetails.sizes) ||
        (c.TeamDetails && c.TeamDetails.Sizes) ||
        null;
    }
    if (!raw) return [];

    // Normalize to [{ size, quantity }] regardless of whether the source is
    // an array of objects or a { S: 2, M: 4 } map.
    if (Array.isArray(raw)) {
      return raw
        .map(function (entry) {
          var size = pickFirstString(entry, ['size', 'Size', 'name', 'Name', 'label', 'Label']);
          var qty = parseInt((entry && (entry.quantity || entry.Quantity || entry.qty || entry.Qty)) || 0, 10) || 0;
          return { size: size, quantity: qty };
        })
        .filter(function (e) { return e.size; });
    }

    if (typeof raw === 'object') {
      return Object.keys(raw).map(function (k) {
        return { size: k, quantity: parseInt(raw[k], 10) || 0 };
      });
    }

    return [];
  }

  function buildSizeBreakdown(sizes) {
    return sizes
      .filter(function (e) { return e.quantity > 0; })
      .map(function (e) { return e.size + ':' + e.quantity; })
      .join(', ');
  }

  // Recursively remove any field whose key matches /price/i (CartPrice,
  // UnitPrice, PriceModifications, VariantPrices, WholesalePrice, etc.) from
  // any object/array we're about to expose on the cart line. We do not want
  // pricing data to ride along on Shopify line item properties.
  function stripPriceFields(value) {
    if (value == null) return value;
    if (Array.isArray(value)) return value.map(stripPriceFields);
    if (typeof value !== 'object') return value;
    var clean = {};
    Object.keys(value).forEach(function (k) {
      if (/price/i.test(k)) return;
      clean[k] = stripPriceFields(value[k]);
    });
    return clean;
  }

  // Build a customer-readable summary of whatever team-detail structure
  // Kit Builder happens to send. Truly generic — no assumptions about which
  // fields, keys, or arrays exist. Walks the data, includes simple primitive
  // leaf values, skips noise (empties, zeros, booleans, long IDs/UUIDs).
  // Returns '' for empty / blank / unrecognizable payloads so the property
  // simply isn't added.
  function buildFriendlyTeamSummary(teamDetails) {
    if (!teamDetails || typeof teamDetails !== 'object') return '';

    function flatten(value, depth) {
      // Depth cap exists only as a safety net against pathological cycles.
      // Set generously — KB's TeamDetails reaches depth 5 just to read
      // unit.Name (teamDetails > Teams > team > Units > unit > Name).
      if (depth > 10) return '';
      if (value == null) return '';

      if (typeof value === 'string') {
        var s = value.trim();
        if (!s.length) return '';
        // Skip very long strings (UUIDs, hashes, base64 blobs) — they're
        // identifier noise, not human-relevant.
        if (s.length > 40) return '';
        return s;
      }
      if (typeof value === 'number') {
        if (!Number.isFinite(value) || value === 0) return '';
        return String(value);
      }
      if (typeof value === 'boolean') return '';

      if (Array.isArray(value)) {
        var items = value
          .map(function (v) { return flatten(v, depth + 1); })
          .filter(function (s) { return s && s.length > 0; });
        return items.length ? items.join(' | ') : '';
      }

      if (typeof value === 'object') {
        var pairs = [];
        Object.keys(value).forEach(function (k) {
          var v = flatten(value[k], depth + 1);
          if (v && v.length) pairs.push(k + ': ' + v);
        });
        return pairs.length ? pairs.join(', ') : '';
      }

      return '';
    }

    return flatten(teamDetails, 0);
  }

  function sumQuantity(sizes) {
    return sizes.reduce(function (sum, e) { return sum + (e.quantity > 0 ? e.quantity : 0); }, 0);
  }

  function hasText(v) {
    return v != null && String(v).trim().length > 0;
  }

  // Walk the Kit Builder TeamDetails and tally how much of the order has a size
  // chosen vs. how much does NOT. Kit Builder fires the add-to-cart callback even
  // when sizes are blank, and it buckets every un-sized player under a single
  // size entry whose `Name` is null (e.g. { Name: null, Quantity: 4 }). Our
  // `extractSizes` drops those name-less buckets, which would silently discard
  // those players from the cart line — so we count them explicitly here.
  //
  // Returns { sizedQty, unsizedQty, productHasSizes }.
  function summarizeSizing(payload) {
    var containers = payloadContainers(payload);
    var td = null;
    for (var i = 0; i < containers.length && !td; i++) {
      td = (containers[i].teamDetails || containers[i].TeamDetails) || null;
    }

    var availableSizes = (td && (td.AvailableSizes || td.availableSizes)) || [];
    var productHasSizes = Array.isArray(availableSizes) && availableSizes.length > 0;

    var sizedQty = 0;
    var unsizedQty = 0;

    // Preferred signal: Kit Builder's aggregated size buckets (authoritative for
    // products where per-unit quantity is hidden).
    var buckets = (td && (td.Sizes || td.sizes)) || [];
    if (Array.isArray(buckets) && buckets.length) {
      buckets.forEach(function (b) {
        if (!b) return;
        var q = parseInt(b.Quantity != null ? b.Quantity : b.quantity, 10) || 0;
        if (q <= 0) return;
        if (hasText(b.Name) || hasText(b.SizeValue) || hasText(b.Size)) sizedQty += q;
        else unsizedQty += q;
      });
    } else if (td && Array.isArray(td.Teams)) {
      // Fallback for products that only carry per-unit data.
      td.Teams.forEach(function (t) {
        if (!t || !Array.isArray(t.Units)) return;
        t.Units.forEach(function (u) {
          if (!u) return;
          // Per-unit Quantity is often 0 when quantities are hidden — count the
          // unit itself as one item in that case.
          var q = parseInt(u.Quantity, 10) || 0;
          if (q <= 0) q = 1;
          if (hasText(u.Size) || hasText(u.SizeValue)) sizedQty += q;
          else unsizedQty += q;
        });
      });
    }

    return { sizedQty: sizedQty, unsizedQty: unsizedQty, productHasSizes: productHasSizes };
  }

  // Decide whether the kit is missing customer input we can't add to the cart
  // without. Kit Builder gives us no explicit "invalid" flag, so we classify it
  // ourselves and return a clear, customer-facing message (or null when the kit
  // is ready). Covers: nothing sized at all, and the partial case where some
  // players are sized and some are not (which must NOT add a short order).
  function findKitInputProblem(payload) {
    var s = summarizeSizing(payload);

    // Product genuinely has no size dimension — size validation doesn't apply.
    if (!s.productHasSizes) return null;

    if (s.sizedQty <= 0 && s.unsizedQty <= 0) {
      return 'Please select a size for each player before adding your design to the cart.';
    }
    if (s.unsizedQty > 0) {
      if (s.sizedQty <= 0) {
        return 'Please select a size for each player before adding your design to the cart.';
      }
      var n = s.unsizedQty;
      return 'Every player needs a size. ' + n + ' player' + (n === 1 ? '' : 's') +
        ' still need' + (n === 1 ? 's' : '') + ' a size selected before you can add this design to your cart.';
    }
    return null; // every item has a size — good to go
  }

  // ==============================================================
  // ====  Personalization mapping (Kit Builder → Shopify)      ====
  // ====  The translation TABLE lives in a separate, clearly   ====
  // ====  named file: assets/kitbuilder-personalization-map.js ====
  // ====  (window.KitBuilderPersonalizationMap). Edit THAT     ====
  // ====  file to add/remove options. The logic below is the   ====
  // ====  generic engine that applies whatever rows it finds.  ====
  // ==============================================================

  // Kit Builder's per-option selections live in SingleItemCheckout.Fields[].
  function getKbFields(payload) {
    var containers = payloadContainers(payload);
    for (var i = 0; i < containers.length; i++) {
      if (containers[i] && Array.isArray(containers[i].Fields)) return containers[i].Fields;
    }
    return [];
  }

  function findFieldByKey(fields, key) {
    for (var i = 0; i < fields.length; i++) {
      if (fields[i] && fields[i].Key === key) return fields[i];
    }
    return null;
  }

  // Match the Shopify personalization option by `name` (case/space-insensitive).
  function findPersonalizationOption(personalizations, name) {
    if (!personalizations || !name) return null;
    var target = String(name).trim().toLowerCase();
    for (var i = 0; i < personalizations.length; i++) {
      if (personalizations[i] && String(personalizations[i].name).trim().toLowerCase() === target) {
        return personalizations[i];
      }
    }
    return null;
  }

  // Match an option entry by its `key` (case-insensitive).
  function findOptionByKey(option, key) {
    var opts = (option && option.options) || [];
    var target = String(key).trim().toLowerCase();
    for (var i = 0; i < opts.length; i++) {
      if (opts[i] && String(opts[i].key).trim().toLowerCase() === target) return opts[i];
    }
    return null;
  }

  // First char upper, rest lower — mirrors the native PDP's Liquid `capitalize`
  // so the kit line value reads identically (e.g. Shopify key "YES" -> "Yes").
  function capitalizeValue(str) {
    var s = String(str);
    if (!s.length) return s;
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }

  /**
   * Apply the Kit Builder → Shopify personalization map, writing the SAME
   * `Personalization` + `additional cost` line properties the native PDP
   * personalize-and-add-to-cart flow produces. Shopify's personalization
   * record drives the label and the price; Kit Builder only supplies which
   * value the customer picked. Mutates `properties` in place.
   *
   * Null/empty/"N/A"/unmapped/unresolvable selections all collapse to the same
   * safe outcome: nothing is written and no upcharge is added.
   */
  function applyPersonalizationMap(payload, personalizations, properties) {
    var map = window.KitBuilderPersonalizationMap;
    if (!Array.isArray(map) || !map.length) return; // map file missing/empty
    if (!personalizations || !personalizations.length) return; // variant has no record

    var fields = getKbFields(payload);
    if (!fields.length) return;

    var lines = [];
    var totalAdditional = 0;

    map.forEach(function (row) {
      if (!row || !row.kbFieldKey || !row.shopifyOptionName) return;

      var kbField = findFieldByKey(fields, row.kbFieldKey);
      if (!kbField) return; // this product didn't include the field — fine

      // 1. Kit Builder value — bail on the null/empty/N/A "not selected" cases.
      if (kbField.Value == null) return;
      var kbValue = String(kbField.Value).trim();
      if (!kbValue || kbValue.toLowerCase() === 'n/a') return;

      // 2. Translate Kit Builder value -> Shopify option key via the map.
      var shopifyKey = row.valueMap ? row.valueMap[kbValue] : kbValue;
      if (!shopifyKey) {
        console.warn('[KitBuilder] no valueMap entry for', row.kbFieldKey, '=', kbValue, '— skipping');
        return;
      }
      if (String(shopifyKey).toLowerCase() === 'n/a') return; // mapped to "none"

      // 3. Resolve against Shopify's record (source of truth for label + price).
      var option = findPersonalizationOption(personalizations, row.shopifyOptionName);
      if (!option) {
        console.warn('[KitBuilder] Shopify personalization option not found:', row.shopifyOptionName, '— skipping');
        return;
      }
      var choice = findOptionByKey(option, shopifyKey);
      if (!choice) {
        console.warn('[KitBuilder] Shopify option key not found:', row.shopifyOptionName, '>', shopifyKey, '— skipping');
        return;
      }

      // 4. Build the line exactly like the native flow.
      var price = parseFloat(choice.price) || 0; // null/blank/NaN -> 0
      lines.push(option.name + ': ' + capitalizeValue(shopifyKey));
      totalAdditional += price;
    });

    if (lines.length) {
      // Single folded text property, matching the native PDP `Personalization`.
      properties['Personalization'] = lines.join('\n');
    }
    if (totalAdditional > 0) {
      // Per-unit upcharge string; the Shopify cart price function multiplies it
      // by quantity and re-calculates on cart quantity changes. Omitted when 0,
      // mirroring the native product (presence/absence encodes the upcharge).
      properties['additional cost'] = '$' + totalAdditional.toFixed(2);
    }
  }

  /**
   * Transform a Kit Builder webhook payload into a Shopify cart.js line shape.
   * Async because it has to resolve the SKU to a variant ID via Storefront API.
   *
   * @param {object} payload Parsed Kit Builder webhook payload
   * @returns {Promise<{id:number, quantity:number, properties:object}>}
   */
  async function transformKitBuilderPayload(payload) {
    var sku = extractSku(payload);
    if (!sku) throw new Error('Kit Builder payload is missing a SKU');

    var sizes = extractSizes(payload);
    var totalQty = sumQuantity(sizes);
    if (totalQty <= 0) throw new Error('Kit Builder payload has no positive quantities');

    var resolved = await lookupVariantBySku(sku);
    var variantId = resolved.variantId;
    var personalizations = resolved.personalizations;

    var containers = payloadContainers(payload);
    var designName = pickStringFromContainers(containers, ['DesignName', 'designName', 'Name', 'name']);
    var productName = pickStringFromContainers(containers, ['ProductName', 'productName']);
    var mainImage = pickStringFromContainers(containers, ['mainImageUrl', 'MainImageUrl']);
    var backImage = pickStringFromContainers(containers, ['backImageUrl', 'BackImageUrl']);
    var publicWebhookId = pickStringFromContainers(containers, ['PublicWebhookId', 'publicWebhookId']);

    // Capture whatever team-detail structure Kit Builder sends, verbatim. The
    // shape varies by product (some have name+number+size, others may add
    // initials, custom fields, multiple teams, etc.) — we don't introspect
    // when serializing the raw blob.
    var teamDetailsObj = null;
    for (var ci = 0; ci < containers.length && !teamDetailsObj; ci++) {
      var c = containers[ci];
      if (c.TeamDetails && typeof c.TeamDetails === 'object') teamDetailsObj = c.TeamDetails;
      else if (c.teamDetails && typeof c.teamDetails === 'object') teamDetailsObj = c.teamDetails;
    }

    var properties = {
      _kb_sku: sku
    };
    if (designName) properties['Design'] = designName;
    // --- Customer-facing "Size Breakdown" line property — TEMPORARILY DISABLED ---
    // Trimmed from the customer-facing order line item (too much detail on the
    // line). Kept here, commented out, in case we want to re-enable it. The raw
    // size data still rides along inside the hidden `_CustomTeamData` blob, and
    // the line `quantity` is still the summed total.
    // var breakdown = buildSizeBreakdown(sizes);
    // if (breakdown) properties['Size Breakdown'] = breakdown;
    if (mainImage) {
      properties['_design_image'] = mainImage;
    } else {
      console.warn('[KitBuilder] payload missing mainImageUrl — design image property will be omitted');
    }
    if (backImage) properties['_design_back_image'] = backImage;
    if (publicWebhookId) properties['_kb_webhook_id'] = publicWebhookId;
    if (productName) properties['_kb_product_name'] = productName;
    if (teamDetailsObj) {
      // Strip any price-related fields before exposing this on the cart line.
      var teamDetailsClean = stripPriceFields(teamDetailsObj);
      // Hidden raw blob (underscore prefix → not rendered to customer in
      // cart drawer) so order export / OMS can read every field.
      try {
        properties['_CustomTeamData'] = JSON.stringify(teamDetailsClean);
      } catch (e) {
        console.warn('[KitBuilder] failed to stringify TeamDetails:', e);
      }
      // --- Customer-facing "CustomTeamData" roster summary — TEMPORARILY DISABLED ---
      // The flattened roster summary was too much info on the customer-facing
      // order line item, so it's commented out (not deleted) in case we want it
      // back. The full roster is still preserved in the hidden `_CustomTeamData`
      // blob above for the order record / OMS.
      // var friendly = buildFriendlyTeamSummary(teamDetailsClean);
      // if (friendly) properties['CustomTeamData'] = friendly;
    }

    // Direct reference to the Kit Builder Form Reply record for this
    // submission — singular and specific, not a generic identifier.
    // Example: 268877135 → https://api.kitbuilder.co.uk/manage/#/formreplies/view/268877135
    var formReplyId =
      payload && payload.SingleItemCheckout && payload.SingleItemCheckout.FormReplyId;
    if (formReplyId || formReplyId === 0) {
      properties['KitBuilderId'] = String(formReplyId);
    }

    // Mirror Kit Builder's personalization selections (e.g. Front Pocket) onto
    // the line as `Personalization` + `additional cost`, driven by Shopify's
    // personalizations record. See assets/kitbuilder-personalization-map.js.
    applyPersonalizationMap(payload, personalizations, properties);

    return {
      id: variantId,
      quantity: totalQty,
      properties: properties
    };
  }

  async function ensureBrandAttribute() {
    try {
      var current =
        (window.globalSpace && window.globalSpace.cart && window.globalSpace.cart.attributes && window.globalSpace.cart.attributes.Brand) || '';
      if (current === BRAND_ATTRIBUTE) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { Brand: BRAND_ATTRIBUTE } })
      });

      if (window.globalSpace && window.globalSpace.cart) {
        window.globalSpace.cart.attributes = window.globalSpace.cart.attributes || {};
        window.globalSpace.cart.attributes.Brand = BRAND_ATTRIBUTE;
      }
    } catch (err) {
      console.warn('[KitBuilder] failed to set Brand cart attribute:', err);
    }
  }

  function refreshAndOpenCartDrawer(addJsonSections) {
    var cartForm = document.querySelector('cart-form');
    if (cartForm && typeof cartForm._updateCart === 'function' && addJsonSections) {
      cartForm._updateCart(addJsonSections);
    }
    var drawer = document.querySelector('#component-cart-drawer');
    if (drawer && typeof drawer.openDrawer === 'function') {
      drawer.openDrawer();
    }
  }

  /**
   * Handler for webhookBuyNowCallback (the "Buy Now" button). Parses,
   * transforms, posts to /cart/add.js, refreshes the drawer and opens it. No
   * navigation. ("Add to Basket" is intentionally not wired — see initKitBuilder.)
   *
   * @param {{content:string}} data Kit Builder callback envelope
   */
  async function addKitToCart(data) {
    if (!data || typeof data.content !== 'string') {
      throw new Error('Kit Builder callback fired without data.content');
    }

    var payload = JSON.parse(data.content);
    console.log('[KitBuilder] payload received', payload);

    // Kit Builder fires this callback even when sizes are blank or only some
    // players are sized. Catch those fixable cases up front and tell the
    // customer exactly what's missing, instead of silently adding a short order
    // (un-sized players get dropped by extractSizes) or failing downstream with
    // a generic error. Return cleanly (no throw) so Kit Builder just dismisses
    // its overlay rather than stacking its own "Error saving cart" alert on top
    // of our specific message.
    var inputProblem = findKitInputProblem(payload);
    if (inputProblem) {
      console.warn('[KitBuilder] kit not ready to add to cart:', inputProblem);
      notifyKitInputProblem(inputProblem);
      return;
    }

    // Past validation — clear any stale notice from a previous attempt.
    clearKitNotice();

    var addJson;
    try {
      var line = await transformKitBuilderPayload(payload);

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [line],
          sections: 'component-cart-drawer,header'
        })
      });

      if (!response.ok) {
        var errBody = '';
        try { errBody = await response.text(); } catch (e) { /* ignore */ }
        var cartErr = new Error('cart/add.js returned HTTP ' + response.status);
        cartErr.name = 'CartAddError';
        cartErr.status = response.status;
        cartErr.body = errBody;
        throw cartErr;
      }

      addJson = await response.json();
    } catch (err) {
      // The kit was valid but Shopify wouldn't add it — variant sold out /
      // unavailable, a cart rule, or a network blip. Surface a persistent,
      // customer-readable error and abort cleanly: do NOT open the cart drawer
      // (that would read as success), and do NOT re-throw (re-throwing only
      // triggers Kit Builder's own generic "Error saving cart" alert on top of
      // our specific message). These are potentially lost orders, so log the
      // full error (incl. Shopify's raw body) for us.
      console.error('[KitBuilder] could not add kit to cart:', err, err && err.body);
      showKitNotice(friendlyCartError(err), 'error');
      return;
    }

    await ensureBrandAttribute();

    refreshAndOpenCartDrawer(addJson.sections);

    if (typeof eventBus !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      eventBus.publish(PUB_SUB_EVENTS.cartUpdate, {
        data: { action: 'add-item', item: addJson, source: 'kitbuilder' }
      });
    }
  }

  function wrapCallback(label) {
    return async function (data) {
      try {
        await addKitToCart(data);
      } catch (err) {
        // addKitToCart surfaces expected failures itself (and returns), so
        // reaching here means an UNEXPECTED error — e.g. a malformed callback
        // envelope that failed JSON.parse. Show the generic error banner rather
        // than dying silently. Not re-thrown: we've already surfaced it.
        console.error('[KitBuilder] ' + label + ' failed:', err);
        showKitNotice(friendlyCartError(err), 'error');
      }
    };
  }

  function initKitBuilder() {
    if (typeof KitBuilder === 'undefined' || !KitBuilder || typeof KitBuilder.init !== 'function') {
      console.error('[KitBuilder] KitBuilder global is not available — bootstrapper script may have failed to load');
      return;
    }

    KitBuilder.init('#kitBuilder', {
      currency: CURRENCY,
      currencySymbol: CURRENCY_SYMBOL,
      currencyFraction: CURRENCY_FRACTION,
      cartItemPricingMethod: 'AggregatePricing',
      customCallbacks: {
        // Only the "Buy Now" button is wired. "Add to Basket" is intentionally
        // left without a callback so Kit Builder does not display it — both
        // buttons ran the same no-redirect handler, so only one is needed.
        // To bring "Add to Basket" back, uncomment the line below.
        // webhookAddSingleItemToCartCallback: wrapCallback('addSingleItemToCart'),
        webhookBuyNowCallback: wrapCallback('buyNow')
      }
    });
  }

  document.addEventListener('KitBuilderLoaded', initKitBuilder);

  // Exposed for debugging / unit testing in the browser console.
  window.__kitBuilderIntegration = {
    transformKitBuilderPayload: transformKitBuilderPayload,
    lookupVariantBySku: lookupVariantBySku,
    addKitToCart: addKitToCart
  };
})();
